import React, {useState, useEffect} from 'react';
import classnames from 'classnames/bind';
import _ from 'lodash';
import QuickSearch from '../FindTheRightOil/QuickSearch';
import VehicleSearch from '../FindTheRightOil/VehicleSearch';
import OilSearch from '../FindTheRightOil/OilSearch';
import LicensePlateSearch from '../FindTheRightOil/LicensePlateSearch';
import '../../style/oil-search-styles.scss';
import style from './index.module.scss';
import instance from '../../services/httpRequest';
import {Replacement} from '../../interface';
import localesReplacement from '../../utils/localesReplacement';
import IconOil from '../../images/oil.svg';
import IconOilSelected from '../../images/oil-selected.svg';
import IconCar from '../../images/icon-car.svg';
import IconLicensePlate from '../../images/license-plate-search.svg';
import IconLicensePlateSelected from '../../images/license-plate-search-selected.svg';
import IconCarSelected from '../../images/icon-car-selected.svg';
import IconClockFastrack from '../../images/icon-clock-fastrack.svg';
import IconClockFastrackSelected from '../../images/icon-clock-fastrack-selected.svg';
import {AxiosResponse} from 'axios';
import {
  ENABLEDWORKSHOPSOWNER,
  ENABLED_LICENSE_PLATE_COUNTRIES,
  NORDICS,
} from '../../constants';
import OwnerSelector from '../OwnerSelector';
import {isQuickSearchDisabled} from '../../utils/isQuickSearchDisabled';
import UnderMaintenance from '../UnderMaintenance';
const cx = classnames.bind(style);

interface IProps {
  country: string;
  i18n?: string;
  baseAPI?: string;
  locales?: Replacement;
  onVehicleSelect?: (
    value: string | number,
    model: string,
    vehicleType?: string,
  ) => void;
  onProductSelect?: (value: string | number) => void;
  onWTBClick?: () => void;
  restore?: boolean;
  preserved?: boolean;
}

const SEARCH_TITLE_QUICK_SEARCH = 'Quick search';
const SEARCH_TITLE_VEHICLE_SEARCH = 'Vehicle search';
const SEARCH_TITLE_OIL_SEARCH = 'Oil search';
const SEARCH_TITLE_LICENSE_PLATE_SEARCH = 'License Plate Search';

const defaultTypes = [
  {
    title: SEARCH_TITLE_QUICK_SEARCH,
    icon: IconClockFastrack,
    alt: 'icon click fastrack',
    iconSelected: IconClockFastrackSelected,
    classname: 'quickSearch',
  },
  {
    title: SEARCH_TITLE_VEHICLE_SEARCH,
    haveSeparator: true,
    icon: IconCar,
    iconSelected: IconCarSelected,
    alt: 'icon car',
    classname: 'vehicleSearch',
  },
  {
    title: SEARCH_TITLE_OIL_SEARCH,
    icon: IconOil,
    iconSelected: IconOilSelected,
    alt: 'icon oil',
    classname: 'oilSearch',
  },
];

function TypeList(props: {
  replacements: Replacement;
  types: any[];
  restore?: boolean;
  searchType: string;
  setSearchType: (v: string) => void;
}) {
  const {replacements, types, restore, searchType, setSearchType} = props;
  return (
    <ul>
      {_.map(types, (t, index) => (
        <li className={cx(t.classname)} key={index}>
          <label>
            <input
              type='radio'
              name='search-type'
              value={t.title}
              onChange={() => {
                setSearchType(t.title);
                localStorage.setItem('searchTab', t.title);
                if (restore) {
                  sessionStorage.clear();
                  sessionStorage.setItem('searchTab', t.title);
                }
              }}
              checked={_.isEqual(searchType, t.title)}
            />
            <div className={cx('search-item')}>
              <div className={cx('bg')}></div>
              <img className={cx('icon')} src={t.icon} alt={t.alt} />
              <img
                className={cx('icon', 'selected')}
                src={t.iconSelected}
                alt={t.alt}
              />
              <span>{localesReplacement(replacements, t.title)}</span>
            </div>
            {t.haveSeparator ? <div className={cx('separator')} /> : null}
          </label>
        </li>
      ))}
    </ul>
  );
}

function LicensePlateSearchHOC(
  props: IProps & {
    replacements: Replacement;
    smartSearch: boolean;
    searchType: string;
    recaptcha: boolean;
    licensePlateRegexes: string;
    selectedIndex: boolean;
  },
) {
  const {
    country,
    replacements,
    i18n,
    selectedIndex,
    smartSearch,
    searchType,
    recaptcha,
    licensePlateRegexes,
    ...rest
  } = props;
  return (
    <>
      {(_.includes(ENABLED_LICENSE_PLATE_COUNTRIES, country) || !smartSearch) &&
        _.isEqual(searchType, SEARCH_TITLE_LICENSE_PLATE_SEARCH) && (
          <LicensePlateSearch
            country={country}
            language={i18n}
            replacements={replacements}
            {...rest}
            selectedWorkshop={
              _.includes(ENABLEDWORKSHOPSOWNER, country) ? selectedIndex : false
            }
            captcha={recaptcha}
            licensePlateRegexes={licensePlateRegexes}
          />
        )}
    </>
  );
}

function FindTheRightOil(props: IProps) {
  const {
    baseAPI,
    country,
    i18n,
    locales,
    onWTBClick,
    restore,
    preserved,
    ...rest
  } = props;
  const [searchType, setSearchType] = useState<string>(
    SEARCH_TITLE_QUICK_SEARCH,
  );
  // eslint-disable-next-line
  const [types, setTypes] = useState<any[]>(defaultTypes);
  //Get vehicles & product data
  if (baseAPI) {
    instance.defaults.baseURL = baseAPI;
  }
  if (country) {
    _.assign(instance.defaults.headers, {countryCode: country});
  }
  if (i18n) {
    _.assign(instance.defaults.headers, {languageCode: i18n});
  }
  const [replacements, setReplacements] = useState<Replacement>({});
  useEffect(() => {
    if (locales) {
      setReplacements(locales);
    }
  }, [locales]);
  const [selectedIndex, setSelectedIndex] = useState<boolean>(
    sessionStorage.getItem('selectedType') === 'true' ? true : false,
  );
  const window: any = globalThis;
  window.dataLayer = window.dataLayer || [];

  const controller = new AbortController();
  const [licence, setLicence] = useState<boolean>(false);
  const [recaptcha, setRecaptcha] = useState<boolean>(false);
  const [smartSearch, setSmartSearch] = useState<boolean>(true);
  const [licensePlateRegexes, setLicensePlateRegexes] = useState<string>('');
  const [type, setType] = useState<string>('');
  const [wtb, setWtb] = useState<boolean>(false);
  const [underMaintnance, setUnderMaintenance] = useState<boolean>(false);

  useEffect(() => {
    window.dataLayer.push({
      event: 'productFinderView',
      userType: selectedIndex ? 'workshop owner' : 'vehicle owner',
      countryCode: country,
      pageType: 'product finder',
    });

    if (_.includes(ENABLED_LICENSE_PLATE_COUNTRIES, country) || !smartSearch) {
      const usaTypes = [...defaultTypes];
      usaTypes.splice(1, 0, {
        title: SEARCH_TITLE_LICENSE_PLATE_SEARCH,
        icon: IconLicensePlate,
        iconSelected: IconLicensePlateSelected,
        alt: 'icon license plate',
        classname: 'licensePlateSearch',
      });
      setTypes(usaTypes);
    } else {
      setTypes(defaultTypes);
    }

    if (isQuickSearchDisabled(country)) {
      const newTypes = defaultTypes.filter(
        (item) => item.title !== SEARCH_TITLE_QUICK_SEARCH,
      );
      if (country === 'POL') {
	newTypes.splice(0, 0, {
          title: SEARCH_TITLE_LICENSE_PLATE_SEARCH,
          icon: IconLicensePlate,
          iconSelected: IconLicensePlateSelected,
          alt: 'icon license plate',
          classname: 'licensePlateSearch',	  
	})
	setSearchType(SEARCH_TITLE_LICENSE_PLATE_SEARCH);
      }
      setTypes(newTypes);
    }
    if (_.isEqual(country, 'TUR')) {
      setSearchType(SEARCH_TITLE_VEHICLE_SEARCH);
    }
    if (NORDICS.includes(country)) {
      setSearchType(SEARCH_TITLE_LICENSE_PLATE_SEARCH);
    }
  }, [smartSearch]);

  useEffect(() => {
    instance
      .get('/data/countrySettings/currentCountrySetting', {
        signal: controller.signal,
      })
      .then((d: AxiosResponse) => {
        if (d) {
          setLicence(d.data.licensePlateSearchEnabled);
          setRecaptcha(d.data.captchaEnabled);
          setSmartSearch(d.data.enableSmartSearch);
          setLicensePlateRegexes(d.data.licensePlateRegexes);
          setType(d.data.serviceProvider);
          setWtb(d.data.whereToBuyForLandingEnabled);
        }
      })
      .catch(() => console.log(`Error`));
    return () => {
      controller.abort();
    };
  }, []);

  //Restore from sessionStorage
  useEffect(() => {
    if (preserved) {
      setSearchType(
        sessionStorage.getItem('searchTab') ?? SEARCH_TITLE_QUICK_SEARCH,
      );
    }
  }, [preserved]);

  useEffect(() => {
    instance
      .get('/categories', {
        signal: controller.signal,
      })
      .then((d: AxiosResponse) => {
        if (d.status !== 200) {
          // enable site under maintenance message
          setUnderMaintenance(true);
        }
      })
      .catch(() => {
         // enable site under maintenance message
         setUnderMaintenance(true);
        console.log(`Error`);
      });
    return () => {
      controller.abort();
    };
  }, []);

  const selectIndex = _.includes(ENABLEDWORKSHOPSOWNER, country)
    ? selectedIndex
    : false;

  return (
    <div className={cx('section', 'castrol-oil-search')} id='oil-search'>
      <div className={cx('heading')}>
        <h3>{localesReplacement(replacements, 'Find the right product')}</h3>
        <p>
          {localesReplacement(
            replacements,
            'With the Castrol Oil Selector it has never been easier to find out which oil is best for you.',
          )}
        </p>
      </div>
      {underMaintnance ? (
        <div>
          <UnderMaintenance replacements={replacements} />
        </div>
      ) : (
        <div>
          {country && _.includes(ENABLEDWORKSHOPSOWNER, country) ? (
            <OwnerSelector
              replacements={replacements}
              selectedIndex={selectedIndex}
              setSelectedIndex={(b) => {
                window.dataLayer.push({
                  event: b ? 'workshopOwnerClicks' : 'vehicleOwnerClicks',
                  countryCode: country,
                });
                setSelectedIndex(b);
                sessionStorage.setItem('selectedType', _.toString(b));
              }}
            />
          ) : null}
          <div className={cx('search-type')}>
            <TypeList
              replacements={replacements}
              types={types}
              restore={restore}
              searchType={searchType}
              setSearchType={setSearchType}
            />
            {wtb && onWTBClick && !restore && (
              <button
                onClick={() => {
                  onWTBClick && onWTBClick();
                }}
              >
                {localesReplacement(replacements, 'Where to Buy')}
              </button>
            )}
          </div>

          {!isQuickSearchDisabled(country) &&
            _.isEqual(searchType, SEARCH_TITLE_QUICK_SEARCH) && (
              <QuickSearch
                language={i18n}
                replacements={replacements}
                switchVehicleSearch={() =>
                  setSearchType(SEARCH_TITLE_VEHICLE_SEARCH)
                }
                country={country}
                licence={licence && smartSearch}
                licensePlateRegexes={licensePlateRegexes}
                selectedWorkshop={selectIndex}
                captcha={recaptcha}
                restore={restore}
                preserved={preserved}
                userType={selectedIndex}
                isExtendedRestApi={type?.includes('extended')}
                {...rest}
              />
            )}
          {_.isEqual(searchType, SEARCH_TITLE_VEHICLE_SEARCH) && (
            <VehicleSearch
              replacements={replacements}
              {...rest}
              categoriesType={type}
              selectedWorkshop={selectIndex}
              restore={restore}
              preserved={preserved}
            />
          )}
          {_.isEqual(searchType, SEARCH_TITLE_OIL_SEARCH) && (
            <OilSearch
              replacements={replacements}
              {...rest}
              selectedWorkshop={selectIndex}
              restore={restore}
              preserved={preserved}
            />
          )}
          <LicensePlateSearchHOC
            replacements={replacements}
            smartSearch={smartSearch}
            searchType={searchType}
            recaptcha={recaptcha}
            licensePlateRegexes={licensePlateRegexes}
            selectedIndex={selectedIndex}
            {...props}
          />
        </div>
      )}
    </div>
  );
}

export default FindTheRightOil;
